import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { homePathForRole } from '@/lib/auth/roles';
import { useApp } from '@/hooks/use-app-context';
import { useTokenGuard } from './use-token-guard';
import type { UserRole } from '@/types/admin.types';

interface AccountantRouteProps {
  children: ReactNode;
}

const normalizeRole = (value: unknown): UserRole => {
  if (value === 'admin' || value === 'collector' || value === 'moderator' || value === 'user' || value === 'accountant' || value === 'super_admin') {
    return value;
  }
  if (value === 'super_admin' || value === 'SUPER_ADMIN') return 'super_admin';
  if (value === 'COLLECTOR' || value === 'COLLECTEUR' || value === 'ANNOTATOR' || value === 'ANNOTATEUR') return 'collector';
  if (value === 'ACCOUNTANT' || value === 'COMPTABLE') return 'accountant';
  return 'user';
};

export function AccountantRoute({ children }: AccountantRouteProps) {
  const { user } = useApp();
  const { isValid } = useTokenGuard();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || 'fr';

  if (!isValid || !user) {
    return <Navigate to={`/${currentLang}/login`} state={{ from: window.location.pathname }} replace />;
  }

  // The accounting space is the accountant's only: an admin has Finance in
  // their own panel.
  if (normalizeRole(user.role) !== 'accountant') {
    return <Navigate to={homePathForRole(user.role, currentLang)} replace />;
  }

  return <>{children}</>;
}
